// Dependency-free on purpose: the production popup queue imports this, so it
// must not pull the flags dev-tools (or `fflate`) into the bundle.

export type E2eBuildEnv = {
  NEXT_PUBLIC_ENVIRONMENT?: string;
  NEXT_PUBLIC_TAURI_E2E?: string;
};

export type E2eMarkerWindow = { __IS_E2E__?: boolean } | undefined;

/** Whether this is a non-production desktop e2e build. */
export const isDesktopE2eBuild = (
  env: E2eBuildEnv = {
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_TAURI_E2E: process.env.NEXT_PUBLIC_TAURI_E2E,
  }
): boolean =>
  env.NEXT_PUBLIC_ENVIRONMENT !== 'production' && env.NEXT_PUBLIC_TAURI_E2E === 'true';

const currentWindow = (): E2eMarkerWindow =>
  typeof window === 'undefined' ? undefined : window;

/**
 * Whether this page is the native desktop e2e lane: a desktop e2e build on a
 * page no Playwright lane marked with `window.__IS_E2E__`. The desktop CDP lane
 * runs the same build but sets that marker from an init script, before any app
 * script, so it is already set when this is read. The native lane cannot
 * inject scripts, so it never sets it. With no window (prerender) there is no
 * marker either, so a desktop e2e build counts as native there too.
 */
export const isNativeDesktopE2eLane = (
  env?: E2eBuildEnv,
  win: E2eMarkerWindow = currentWindow()
): boolean => isDesktopE2eBuild(env) && win?.__IS_E2E__ !== true;
